export default "__VITE_ASSET__DLb96LfH__"